import { render, staticRenderFns } from "./popupPermissions.vue?vue&type=template&id=40c323e4&scoped=true&"
import script from "./popupPermissions.vue?vue&type=script&lang=js&"
export * from "./popupPermissions.vue?vue&type=script&lang=js&"
import style0 from "./popupPermissions.vue?vue&type=style&index=0&id=40c323e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c323e4",
  null
  
)

export default component.exports